/* ============================================================================
   BOÎTES DE DIALOGUE STYLÉES
   ----------------------------------------------------------------------------
   Remplacent les confirm()/alert() natifs (hors charte) par une fenêtre au
   design de l'app. `confirmDialog` renvoie une Promise<boolean> ; `alertDialog`
   une Promise<void>. Construites à la volée, sans markup dans index.html.
   ========================================================================== */

let closeCurrent = null;   // ferme la boîte ouverte (une seule à la fois)

/* Confirmation OUI/NON. options : { title, message, confirmLabel, cancelLabel,
   danger } — `danger` colore l'action en rouge (suppression). */
export function confirmDialog(options = {}) {
  return openDialog({ ...options, kind: "confirm" });
}

/* Simple message d'information (remplace alert). */
export function alertDialog(options = {}) {
  return openDialog({ ...options, kind: "alert" }).then(() => undefined);
}

function openDialog({ title = "Confirmer", message = "", confirmLabel, cancelLabel = "Annuler", danger = false, kind = "confirm" }) {
  return new Promise((resolve) => {
    if (closeCurrent) closeCurrent(false);

    const okLabel = confirmLabel || (kind === "alert" ? "OK" : danger ? "Supprimer" : "Confirmer");
    const backdrop = document.createElement("div");
    backdrop.className = "modal-backdrop";
    backdrop.innerHTML = `
      <div class="modal" role="${kind === "alert" ? "alertdialog" : "dialog"}" aria-modal="true" aria-labelledby="modalTitle" aria-describedby="modalMsg">
        <h3 class="modal__title" id="modalTitle"></h3>
        <p class="modal__msg" id="modalMsg"></p>
        <div class="modal__actions"></div>
      </div>`;
    backdrop.querySelector(".modal__title").textContent = title;
    backdrop.querySelector(".modal__msg").textContent = message;

    const actions = backdrop.querySelector(".modal__actions");
    let cancelBtn = null;
    if (kind === "confirm") {
      cancelBtn = document.createElement("button");
      cancelBtn.className = "ghost";
      cancelBtn.textContent = cancelLabel;
      cancelBtn.addEventListener("click", () => finish(false));
      actions.appendChild(cancelBtn);
    }
    const okBtn = document.createElement("button");
    okBtn.className = danger ? "danger" : "primary";
    okBtn.textContent = okLabel;
    okBtn.addEventListener("click", () => finish(true));
    actions.appendChild(okBtn);

    const onKey = (e) => {
      if (e.key === "Escape") { e.preventDefault(); finish(false); }
      else if (e.key === "Enter") { e.preventDefault(); finish(true); }
    };
    // Clic sur le voile (hors fenêtre) = annulation.
    backdrop.addEventListener("mousedown", (e) => { if (e.target === backdrop) finish(false); });
    document.addEventListener("keydown", onKey);

    let settled = false;
    function finish(value) {
      if (settled) return; settled = true;
      document.removeEventListener("keydown", onKey);
      closeCurrent = null;
      backdrop.classList.remove("is-open");
      const remove = () => backdrop.remove();
      backdrop.addEventListener("transitionend", remove, { once: true });
      setTimeout(remove, 250);   // filet de sécurité si la transition ne se déclenche pas
      resolve(value);
    }
    closeCurrent = finish;

    document.body.appendChild(backdrop);
    // Ouverture sur la frame suivante pour jouer la transition d'entrée.
    requestAnimationFrame(() => { backdrop.classList.add("is-open"); okBtn.focus(); });
  });
}
